'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Calendar = require('./Calendar');

var _Calendar2 = _interopRequireDefault(_Calendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Calendar2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-calendar/lib/index.js
// module id = 684
// module chunks = 0